import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <ContactSection />
        <CommentsSection />
        <UpdatesSection />
        <TopicsSection />
        <FeaturesSection />
        <FaqSection />
        <CardsSection />
        <MediaSection />
        <RankingSection />
        <AboutSection />
        <AppSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}